import PocketBase, { LocalAuthStore } from "pocketbase";

import { STORAGE_KEY_PREFIX } from "#composables/use-storage-state";
import { appConfig } from "#config/app";
import { sleep } from "#utilities/sleep";

/** Pocketbase client */
export const pb = new PocketBase(
  appConfig.links.api,
  new LocalAuthStore(`${STORAGE_KEY_PREFIX}-pb-auth`),
);

pb.afterSend = async (_response, data) => {
  // Apply fake delay in development to simulate remote network calls
  if (appConfig.development) {
    await sleep(250);
  }

  return data;
};

/** Pocketbase collection names */
export const pbCollectionNames = {
  content: "content",
  composers: "userComposer",
  collaborators: "userCollaborator",
  feedback: "submissionFeedback",
  featureFlags: "featureFlag",
  seasons: "season",
  submissions: "submission",
  submissionTiers: "submissionTier",
  reviews: "submissionReview",
} as const;

// TODO: Consider extracting back-expansion (ie. via) into separate type/utility
/**
 * Pocketbase nested expansion fields (names) per collection
 *
 * NOTE: Nested expansion values **must** match PB field names!
 * NOTE: Back-expansion values **must** match expected PB `[collection]_via_[field]` format!
 */
export const pbCollectionExpansions = {
  composer: ["submission_via_composer"],
  feedback: ["collaborator", "submission"],
  reviews: ["collaborator", "submission"],
  season: ["submissionTier_via_season"],
  submissions: [
    "assignedCollaborator",
    "composer",
    "season",
    "releasedBy",
    "submissionFeedback_via_submission",
    "submissionPayment",
    "submissionReview_via_submission",
    "submissionTier",
    "submissionTier_via_season",
  ],
  submissionTier: ["season"],
} as const;
